module.exports = __webpack_public_path__ + "static/img/pic9.5146ccc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic9.png
// module id = YKNs
// module chunks = 0